import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V_Detail = {
  '@id': string;
  '@type': 'PsychologyPrompt';
  id: string;
  title: string;
  description: string;
  userAnswer: {
    '@id': string;
    '@type': 'UserSimpleAnswer';
    id: string;
    answer: string;
  } | null;
};

export type V_DetailAsAdmin = {
  '@id': string;
  '@type': 'PsychologyPrompt';
  id: string;
  title: string;
  position: number;
  description: string;
  publishedAt: string | null;
};

export type V_ProgramWeekSub = {
  '@id': string;
  '@type': 'PsychologyPrompt';
  id: string;
  title: string;
  position: number;
  description: string;
  publishedAt: string | null;
  updatedAt: string | null;
};

export type W = {
  title: string;
  position: number;
  description: string;
  week: string;
};

export function useReadCollectionProgramWeekAsAdminSub(
  id: string,
  queryParams?: {
    'order[position]'?: string;
    'order[updatedAt]'?: string;
    title?: string;
  },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ProgramWeekSub>>(
    `/program-weeks/${id}/psychology-prompts/as-admin${makeQueryString(
      queryParams,
    )}`,
    options,
  );
}

export function useReadCollectionProgramWeekSub(
  id: string,
  queryParams?: {
    'order[position]'?: string;
    'order[updatedAt]'?: string;
    title?: string;
  },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ProgramWeekSub>>(
    `/program-weeks/${id}/psychology-prompts${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V_Detail>(`/psychology-prompts/${id}`, options);
}

export function useReadItemAsAdmin(id: string, options?: ReadConfig) {
  return useApiRead<V_DetailAsAdmin>(
    `/psychology-prompts/${id}/as-admin`,
    options,
  );
}
